import React from "react";

interface CategorySliderProps {
  label: string;
  value: number;
  onChange: (value: number) => void;
  descriptions: Record<string, Record<number, string>>;
}

const CategorySlider: React.FC<CategorySliderProps> = ({
  label,
  value,
  onChange,
  descriptions,
}) => {
  const categoryKey = label.toLowerCase();
  const description =
    descriptions[categoryKey]?.[value] ||
    `No moderation set yet, slide to begin`;

  return (
    <div className="mb-4">
      {/* Category Title */}
      <div className="text-sm font-medium text-gray-200 mb-0 mt-6">{label}</div>

      {/* Flex container for slider+labels and description */}
      <div className="flex items-start">
        {/* Container for the slider and its "Lenient" / "Strict" labels */}
        <div className="flex-grow mr-4">
          <input
            type="range"
            min="0.5"
            max="1"
            step={0.1}
            value={value}
            onChange={(e) => onChange(parseFloat(e.target.value))}
            className={`
              w-full h-2 bg-gray-700 rounded-lg appearance-none cursor-pointer [direction:rtl]
              ${value == 0 || value == null ? "opacity-50" : ""}
              
              /* Webkit (Chrome, Safari, Edge) */
              [&::-webkit-slider-thumb]:appearance-none
              [&::-webkit-slider-thumb]:w-4
              [&::-webkit-slider-thumb]:h-4
              [&::-webkit-slider-thumb]:rounded-full
              [&::-webkit-slider-thumb]:bg-violet
              [&::-webkit-slider-thumb]:cursor-pointer
              [&::-webkit-slider-thumb]:hover:bg-violet
              
              /* Firefox */
              [&::-moz-range-thumb]:w-4
              [&::-moz-range-thumb]:h-4
              [&::-moz-range-thumb]:rounded-full
              [&::-moz-range-thumb]:border-0
              [&::-moz-range-thumb]:bg-violet
              [&::-moz-range-thumb]:cursor-pointer
              [&::-moz-range-thumb]:hover:bg-violet
            `}
          />
          {/* "Lenient" and "Strict" labels below the slider bar */}
          <div className="flex justify-between text-xs text-gray-400 mt-1">
            <span>Lenient</span>
            <span>Strict</span>
          </div>
        </div>

        {/* Description text to the right */}
        <div className="w-1/3 text-xs text-gray-500 pl-2 min-h-[3em] flex items-center">
          <div className="line-clamp-3">
            {description}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CategorySlider;
